import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "./useAppContext";

export function useIsDarkForced() {
	const { platform, reactQueryNoReloadOptions } = useAppContext();

	return useQuery<boolean>({
		queryKey: ["use-is-dark-forced"],
		queryFn: () => platform.colorScheme.getIsDarkForcedAsync(),
		...reactQueryNoReloadOptions,
		retry: false,
	});
}
